import { Button } from "@twilio-paste/core";
import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";
import { useTheme } from "@twilio-paste/theme";
import React from "react";
import { HamburgerToggle } from "./HamburgerToggle";
import { HeaderLogo } from "./HeaderLogo";
import { MobileNavigation } from "./HeaderMobileNavigation";

interface HeaderProps {
    searchValue?: string;
    onSearchChange?: (newSearchValue: string) => void;
}

const StyledHeaderRightContainer = styled(Box)(
    css({
        display: ["flex", "flex", "none"],
        marginTop: "space20",
        marginBottom: "space20",
        marginRight: "space70",
        marginLeft: "auto"
    })
);
const Header: React.FC<HeaderProps> = ({ searchValue = "", onSearchChange }) => {
    const theme = useTheme();
    const [navigationOpen, setNavigationOpen] = React.useState(false);

    return (
        <Box
            style={{
                gridArea: "header"
            }}
            as="header"
            display={["flex", "flex", "flex"]}
            alignItems="stretch"
            backgroundColor="colorBackgroundBodyInverse"
            borderBottomColor="colorBorderInverseWeaker"
            borderBottomWidth="borderWidth10"
            borderBottomStyle="solid"
            position="sticky"
            top="0px"
            zIndex="zIndex80"
            paddingTop="space40"
            paddingBottom="space40"
        >
            <HeaderLogo title="Flex UI" subtitle="API Reference" />
            <StyledHeaderRightContainer>
                <Button
                    aria-label="Open main navigation"
                    variant="inverse"
                    size="icon_small"
                    onClick={() => setNavigationOpen(!navigationOpen)}
                >
                    <HamburgerToggle toggled={navigationOpen} color="colorTextInverse" />
                </Button>
                <MobileNavigation isOpen={navigationOpen} onClose={() => setNavigationOpen(false)} />
            </StyledHeaderRightContainer>
        </Box>
    );
};

export { Header };
